var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "j-modal",
    {
      ref: "jmodal",
      attrs: {
        title: _vm.title,
        width: _vm.width,
        visible: _vm.visible,
        switchFullscreen: "",
        okButtonProps: { class: { "jee-hidden": _vm.disableSubmit } },
        "ok-disabled": true,
        fullscreen: true,
        cancelText: _vm.language["common.closeButton"]
      },
      on: {
        ok: _vm.handleOk,
        cancel: _vm.handleCancel,
        setInnerFullscreen: _vm.setInnerFullscreen
      }
    },
    [
      _vm.visible
        ? _c("cms-content-tbl-list", {
            ref: "realForm",
            attrs: { colid: this.colid, onlyView: _vm.onlyView }
          })
        : _vm._e(),
      _c(
        "template",
        { slot: "footer" },
        [_c("a-button", { on: { click: _vm.handleCancel } }, [_vm._v("关闭")])],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }